import { HttpClient } from "./httpClient/HttpClient";
import { windowsService } from "./windowsService";
import { FileType } from "@/App/types/twiageTypes";

export async function openProductGuideInNewWindow(): Promise<void> {
  const pdfUrl = await HttpClient.getBlob({
    path: "/product-guide",
    fileType: FileType.Pdf,
  });

  windowsService.openInNewWindow(pdfUrl);
}
